var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3451 0.566512C24.2424 0.0543101 25.3956 0.363801 25.9171 1.25878C26.4427 2.15535 26.1398 3.29451 25.2402 3.81284L6.69383 14.3989C5.72607 14.9556 4.48471 14.5462 4.02949 13.5288L0.926235 6.60489C0.502786 5.65851 0.931219 4.55027 1.88114 4.13482C2.83105 3.71936 3.94868 4.15142 4.37213 5.0978L6.62023 10.1222L23.3451 0.566512Z",
    fill: "#00A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconBlue);
export default __webpack_public_path__ + "static/media/rightIconBlue.846c563dc79ac3bc1075c3a6ae0521e8.svg";
export { ForwardRef as ReactComponent };